import { TailwindColors } from "@components/common/types/general";
import { type InputTextProps } from "./input-text";

export function getComponentColorProp(
    outline: InputTextProps["outline"],
    underline: InputTextProps["underline"],
    outlineKeepOnHover: InputTextProps["outlineKeepOnHover"],
    color: InputTextProps["color"],
    clean: InputTextProps["clean"],
): keyof TailwindColors | undefined {
    if (underline || (outline && outlineKeepOnHover) || clean || outline) {
        return color;
    }
    if (color === undefined) return "white";
    if (color === "white") return undefined;
    return "white";
}
